<template>
  <ul>
    <li v-for="node in data" :key="node._id">
      <a>
        <div class="member-view-box">
          <div class="member-image">
            <img
              :src="getEmployeeImage(node)"
              @error="handleImageError"
              alt="Employee Image"
              v-if="node.profileImage"
            />
            <v-icon v-else class="iconStyle" style="font-size: 60px">
              mdi-account-circle
            </v-icon>
            <div>
              <h3 class="text-md font-bold">{{ node.fullName }}</h3>
              <h3 class="text-md font-bold text-[#21427D]">
                {{ node.wfmRole && node.wfmRole.role }}
              </h3>
            </div>
          </div>
        </div>
      </a>
      <HierarchyTree
        v-if="node.children && node.children.length"
        :data="node.children"
        class="hierarchy-tree"
      />
    </li>
  </ul>
</template>

<script>
export default {
  name: "HierarchyTree",
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_S3_BASE_URL,
      fallbackImage: require("~/assets/img/genericImage.png"),
    };
  },
  methods: {
    handleImageError(event) {
      event.target.src = this.fallbackImage;
    },

    getEmployeeImage(item) {
      if (item.profileImage) {
        return `${this.baseUrl}${item.profileImage}`;
      } else {
        if (item.gender === "M") {
          return require("~/assets/img/profileMale.png");
        } else if (item.gender === "F") {
          return require("~/assets/img/profileFemale.png");
        } else {
          return require("~/assets/img/genericImage.png");
        }
      }
    },
  },
};
</script>

<style scoped>
.node {
  position: relative;
  text-align: center;
  margin-top: 20px;
}

.label {
  background-color: #3b82f6;
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.children {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  padding-left: 20px;
}

.node::before {
  content: "";
  position: absolute;
  top: -20px;
  left: 50%;
  border-left: 2px solid #ffffff;
  height: 20px;
  width: 0;
}

.node::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  border-top: 2px solid #ffffff;
  height: 0;
  width: calc(100% - 40px);
  margin: auto;
}

.treeview-scroll::-webkit-scrollbar {
  width: 5px;
  height: 8px;
}
.treeview-scroll::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #e4e4e4;
}
.treeview-scroll::-webkit-scrollbar-thumb {
  background: #212121;
  border-radius: 10px;
  transition: 0.5s;
}
.treeview-scroll::-webkit-scrollbar-thumb:hover {
  background: #21427d;
  transition: 0.5s;
}

.treeview-body {
  overflow-y: hidden;
  padding: 50px;
  min-height: 500px;
  padding-top: 10px;
  text-align: center;
}
.hierarchy-tree {
  display: inline-block;
}
.hierarchy-tree ul {
  padding-top: 20px;
  position: relative;
  padding-left: 0px;
  display: flex;
  justify-content: center;
}
.hierarchy-tree li {
  text-align: center;
  list-style-type: none;
  position: relative;
  padding: 20px 5px 0 5px;
}
.hierarchy-tree li::before,
.hierarchy-tree li::after {
  content: "";
  position: absolute;
  top: 0;
  right: 50%;
  border-top: 2px solid #ccc;
  width: 50%;
  height: 18px;
}
.hierarchy-tree li::after {
  right: auto;
  left: 50%;
  border-left: 2px solid #ccc;
}
.hierarchy-tree li:only-child::after,
.hierarchy-tree li:only-child::before {
  display: none;
}
.hierarchy-tree li:only-child {
  padding-top: 0;
}
.hierarchy-tree li:first-child::before,
.hierarchy-tree li:last-child::after {
  border: 0 none;
}
.hierarchy-tree li:last-child::before {
  border-right: 2px solid #ccc;
  border-radius: 0 5px 0 0;
  -webkit-border-radius: 0 5px 0 0;
  -moz-border-radius: 0 5px 0 0;
}
.hierarchy-tree li:first-child::after {
  border-radius: 5px 0 0 0;
  -webkit-border-radius: 5px 0 0 0;
  -moz-border-radius: 5px 0 0 0;
}
.hierarchy-tree ul ul::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  border-left: 2px solid #ccc;
  width: 0;
  height: 20px;
}
.hierarchy-tree li a {
  text-decoration: none;
  color: #000;
  font-family: arial, verdana, tahoma;
  font-size: 14px;
  display: inline-block;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
}

.hierarchy-tree li a:hover + ul li::after,
.hierarchy-tree li a:hover + ul li::before,
.hierarchy-tree li a:hover + ul::before,
.hierarchy-tree li a:hover + ul ul::before {
  border-color: #21427d;
}

.member-view-box {
  padding: 0px 20px;
  text-align: center;
  border-radius: 4px;
  position: relative;
}
.member-image {
  width: 100px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.member-image img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #000;
  z-index: 1;
}

.member-image .iconStyle {
  width: 60px;
  height: 60px;
  border-radius: 6px;
  z-index: 1;
}
</style>
